import * as z from "zod";
import { WORKFLOW_LINK_CORNERS } from "../workflowLink";
import { mutator } from "./mutator";

export const updateWorkflowLink = mutator({
  description:
    "Shows, hides, or moves the “Open in 3B” button on a workflow’s links.",
  interactionType: "update",
  schema: z.object({
    workflowId: z.string(),
    hidden: z.boolean().optional(),
    corner: z.enum(WORKFLOW_LINK_CORNERS).optional(),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { workflow, hidden, corner } }) => {
    await tx.mutate.workflows.update({
      id: workflow.id,
      ...(hidden !== undefined && { workflowLinkHidden: hidden }),
      ...(corner !== undefined && { workflowLinkCorner: corner }),
    });
  },
});
